import React from 'react';
import './Dashboard.css';

const Dashboard = () => {
  // Mock data - in a real app, this would come from an API
  const metrics = [
    {
      id: 'users',
      title: 'User Registration',
      value: '12,575',
      change: '+12.5%',
      changeType: 'positive',
      icon: 'bi-people',
      color: 'purple'
    },
    {
      id: 'subscriptions',
      title: 'Subscription Conversion',
      value: '68.2%',
      change: '+8.2%',
      changeType: 'positive',
      icon: 'bi-credit-card',
      color: 'green'
    },
    {
      id: 'assessments',
      title: 'Assessment Usage',
      value: '1,852',
      change: '-2.1%',
      changeType: 'negative',
      icon: 'bi-clipboard-check',
      color: 'orange'
    },
    {
      id: 'revenue',
      title: 'Revenue Tracking',
      value: '$54,320',
      change: '+5.4%',
      changeType: 'positive',
      icon: 'bi-graph-up',
      color: 'blue'
    }
  ];

  return (
    <div className="dashboard">
      {/* Dashboard Header */}
      <div className="dashboard-header">
        <div className="dashboard-title-section">
          <h1 className="dashboard-title">Dashboard</h1>
          <p className="dashboard-subtitle">Welcome back! Here's what's happening.</p>
        </div>
        <div className="dashboard-actions">
          <button className="action-btn" aria-label="Settings">
            <i className="bi bi-gear"></i>
          </button>
        </div>
      </div>

      {/* Metrics Cards */}
      <div className="metrics-grid">
        {metrics.map((metric) => (
          <div key={metric.id} className={`metric-card metric-card--${metric.color}`}>
            <div className="metric-card__icon">
              <i className={`${metric.icon} metric-icon`}></i>
            </div>
            <div className="metric-card__content">
              <h3 className="metric-title">{metric.title}</h3>
              <div className="metric-value">{metric.value}</div>
              <div className={`metric-change metric-change--${metric.changeType}`}>
                <i className={`bi bi-arrow-${metric.changeType === 'positive' ? 'up' : 'down'}`}></i>
                {metric.change}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Additional Dashboard Content */}
      <div className="dashboard-content">
        <div className="dashboard-section">
          <h2 className="section-title">Recent Activity</h2>
          <div className="activity-list">
            <div className="activity-item">
              <div className="activity-icon">
                <i className="bi bi-person-plus"></i>
              </div>
              <div className="activity-content">
                <p className="activity-text">New user registered: john.doe@example.com</p>
                <span className="activity-time">2 minutes ago</span>
              </div>
            </div>
            <div className="activity-item">
              <div className="activity-icon">
                <i className="bi bi-credit-card"></i>
              </div>
              <div className="activity-content">
                <p className="activity-text">Subscription upgraded to Pro plan</p>
                <span className="activity-time">15 minutes ago</span>
              </div>
            </div>
            <div className="activity-item">
              <div className="activity-icon">
                <i className="bi bi-clipboard-check"></i>
              </div>
              <div className="activity-content">
                <p className="activity-text">Assessment completed by user_123</p>
                <span className="activity-time">1 hour ago</span>
              </div>
            </div>
          </div>
        </div>

        <div className="dashboard-section">
          <h2 className="section-title">Quick Stats</h2>
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-label">Active Users</div>
              <div className="stat-value">8,432</div>
            </div>
            <div className="stat-item">
              <div className="stat-label">Total Assessments</div>
              <div className="stat-value">15,678</div>
            </div>
            <div className="stat-item">
              <div className="stat-label">Conversion Rate</div>
              <div className="stat-value">68.2%</div>
            </div>
            <div className="stat-item">
              <div className="stat-label">Monthly Revenue</div>
              <div className="stat-value">$54,320</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
